import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-10 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-amber-500 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold text-slate-900">Zahlung abgebrochen</h1>
        <p className="text-slate-500 mt-2">Deine Buchung wurde als offen gespeichert. Du kannst die Zahlung später abschließen.</p>
        <Button className="mt-6 bg-emerald-600 hover:bg-emerald-700 w-full" onClick={() => navigate("/")} data-testid="back-home-btn">Zurück zur Startseite</Button>
      </div>
    </div>
  );
}
